import { DynamicFormV2Palette } from "@mui/material";

export type FormCounterComponentTokenType = {
  valueBoxBackgroundColor: string;
  valueBoxBorderColor: string;
};

export const assignCounterComponentTokens = (formsPalette: DynamicFormV2Palette["forms"], mode: "light" | "dark") => {
  const isLightMode = mode === "light";

  return {
    valueBoxBackgroundColor: isLightMode ? formsPalette.surface.reverse : formsPalette.surface.supershy,
    valueBoxBorderColor: isLightMode ? formsPalette.border.moderate : formsPalette.border.intense,
  } as FormCounterComponentTokenType;
};
